class QueryStringUtils {
  static replaceQueryString(param: string, value: string) {
    const newUrl = this.generateQueryStringWithNewParam(param, value);

    this.setUrl(newUrl.replace('##', '#').replace('/?', '/#?'));
  }

  static addQueryStringParamToUrl(url: string, param: string, value: string) {
    const re = getParamRegExp(param);
    const matches = re.exec(url);
    let newUrl;

    if (matches === null) {
      const delimeter = url.indexOf('#?') !== -1 ? '&' : '#?';

      newUrl = url + delimeter + param + '=' + value;
    } else {
      newUrl = url.replace(re, '$1' + param + '=' + value + '$2');
    }

    return newUrl;
  }

  static removeQueryStringParam(param: string) {
    const re = getParamRegExp(param);
    const url = window.location.toString();
    const matches = re.exec(url);

    if (matches === null) {
      return;
    }

    const newUrl = window.location.toString().replace(re, '');

    this.setUrl(newUrl);
  }

  static generateQueryStringWithNewParam(param: string, value: string) {
    const url = window.location.toString();

    return QueryStringUtils.addQueryStringParamToUrl(url, param, value);
  }

  static setUrl(url: string) {
    window.location.href = url;
  }

  static getParameterValue(param: string) {
    const url = window.location.hash.toString();

    const QueriesObj = {};

    url.replace(/[#/?]/g, '').replace(/([^=&]+)=([^&]*)/g, (m: string, key: string, value: string) => {
      QueriesObj[decodeURIComponent(key)] = decodeURIComponent(value);

      return '';
    });

    if (QueriesObj[param]) {
      return QueriesObj[param];
    }

    return false;
  }

  static checkIfExperimental() {
    return window.location.hostname.includes('experimental');
  }
}

function getParamRegExp(param: string) {
  return new RegExp('([?|&])' + param + '=.*?(&|$)', 'i');
}

export default QueryStringUtils;
